import { BASE_PATHS } from "./routeConstants";

export const PROGRAMMING_CONTENT_PATH_REGEX = new RegExp(
  `^${BASE_PATHS.PROGRAMMING_CONTENT}\\/([^/]+)(?:\\/[^/]+)?$`
);
